var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthLayout',{attrs:{"center":""}},[_c('LoginForm',{attrs:{"slot":"form"},slot:"form"}),_c('AuthLeftContent',{attrs:{"slot":"content"},slot:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }